<h2 mat-dialog-title>How Many Nominees Should a Judge Rate?</h2>
<mat-dialog-content>
    <p>
        If there are too many nominees for every judge to rate every nominee, you can split the nominees into groups.
        Choose the size of the groups, and see how the groups will be split in the table below.
        You cannot change any districts after any judge has submitted a rating.
    </p>
    <p><span class="red">Hint: </span>Try to choose a number that is divisible by the number of nominees and/or the number of judges</p>

    <p>Number of Judges: <strong>{{JudgeCount}}</strong></p>
    <p>Number of Nominees: <strong>{{NomCount}}</strong></p>

    <small>Choose number of nominees per group:</small>
    <mat-slider min="1" max="{{NomCount}}" value="{{NomCount}}" step="1" thumbLabel tickInterval="1" (change)="sliderValue($event)"></mat-slider>

    <mat-card class="calc">
        <div *ngIf="Selected.Invalid === false">
            <small>Break-down of how many judges and nominees will be in each group:</small>
            <table>
                <tr>
                    <th>Group</th>
                    <th>Judge Count</th>
                    <th>Nominee Count</th>
                </tr>
                <tr *ngFor="let group of Selected.Table; let i = index">
                    <td>{{i + 1}}</td>
                    <td>{{group.JudgePerGroup}}</td>
                    <td>{{group.NomPerGroup}}</td>
                </tr>
            </table>
        </div>
        <div *ngIf="Selected.Invalid === true">
            <p>This selection is invalid</p>
        </div>
    </mat-card>

</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <div>
        <button mat-raised-button type="button" [color]="'accent'" (click)="CancelHandler()">Cancel</button>
        <button mat-raised-button type="button" [color]="'primary'" (click)="OkHandler()" [disabled]="Selected.Invalid === true">Submit</button>
    </div>
    <div>
        <button mat-raised-button type="button" [color]="'primary'" (click)="ResetHandler()">Reset to Defaults</button>
    </div>
</mat-dialog-actions>